import React from "react";

interface Props {
  product: {
    title?: string;
    cost_price?: number;
    retail_price?: number;
  };
}

export const ProductInfoCard: React.FC<Props> = ({ product }) => (
  <div className="mb-4 bg-gray-50 px-3 rounded-md border border-gray-100 flex items-center justify-between gap-4">
    <div>
      <span className="text-[11px] text-gray-400 block uppercase tracking-wide">
        Product
      </span>
      <span className="text-sm font-medium text-gray-800">{product.title}</span>
    </div>
    <div className="flex gap-4 text-right">
      <div>
        <span className="text-[11px] text-gray-400 block">Cost Price</span>
        <span className="text-xs font-semibold text-gray-700">
          Rs. {product.cost_price?.toFixed(2)}
        </span>
      </div>
      <div>
        <span className="text-[11px] text-gray-400 block">Retail Price</span>
        <span className="text-xs font-semibold text-green-600">
          Rs. {product.retail_price?.toFixed(2)}
        </span>
      </div>
    </div>
  </div>
);
